import TemplateView from '../../TemplateView'
import ResizableInput from '../ResizableInput'
import {isCtrlPressed, isEnter, isShiftPressed} from '../../keyHandlers'
import Button from "../../components/Button"
import messageResource from "../../messageResource"
import {NUMBER_ALLOWED_CHARACTERS} from './constants'

export default class EditCommentInput extends TemplateView {
    constructor({
        onCommentEditedCb = () => {},
        onCancelCb = () => {},
        onEditingTextChanged = () => {},
        refreshScrollCb = () => {},
    }) {
        super()

        this.callbacks = {
            onCommentEditedCb,
            onCancelCb,
            onEditingTextChanged,
            refreshScrollCb,
        }

        this.state = {
            text: '',
        }

        this.onStatePropertyChanged('text', text => {
            this.input.setState({text})
            this._update()
        })
    }

    templateHtml() {
        return "<div class='components_commentInput'>" +
               "        <div class='inputArea'/>" +
               "        <div class='sendCommentLine'>" +
               "            <div class='errorText'/>" +
               "            <div class='buttonsContainer'/>" +
               "        </div>" +
               "</div>"
    }

    afterRender() {
        this.input = new ResizableInput({
            showCounter: false,
            heightLimit: 300,
            minHeight: 75,
            maxLength: NUMBER_ALLOWED_CHARACTERS,
            allowInputOverMaxLength: true,
            onBlur: (text) => {
                if (text !== ''){
                    this.callbacks.onEditingTextChanged(text)
                }
            },
            onKeyDown: (e) => this._handleKeyDown(e),
            onChange: (text) => {
                this.setState({text})
                this.callbacks.refreshScrollCb()
            }
        }).init(this.find('.inputArea'))
        this.input.focus()

        this.saveButton = new Button({
            additionalClass: 'saveChangesBtn',
            label: messageResource.getMessage('panel.common.comments.edit.save_changes'),
            onClickCb: () => this._handleSaveClick()
        }).init(this.find('.buttonsContainer'))

        new Button({
            additionalClass: 'cancelBtn',
            label: messageResource.getMessage('common.cancel'),
            onClickCb: this.callbacks.onCancelCb
        }).init(this.find('.buttonsContainer'))

        this.$errorText = this.find('.errorText')

        this.renderInitialState()
    }

    _update() {
        const characterCount = this.state.text.length
        const allowSend = this.state.text !== '' && characterCount <= NUMBER_ALLOWED_CHARACTERS
        this.saveButton.setState({disabled: !allowSend})
        this.$errorText.toggle(characterCount > NUMBER_ALLOWED_CHARACTERS)

        if (characterCount > NUMBER_ALLOWED_CHARACTERS) {
            const exceededCharacters = characterCount - NUMBER_ALLOWED_CHARACTERS
            this.$errorText.text(
                messageResource.getMessage('panel.common.comments.number_characters_exceeded', [NUMBER_ALLOWED_CHARACTERS, exceededCharacters]))
        }
    }

    _handleSaveClick() {
        const text = this.input.getText()
        if (text !== '') {
            this.callbacks.onEditingTextChanged(text)
            this.callbacks.onCommentEditedCb()
        }
    }

    _handleKeyDown(e) {
        if (isEnter(e.keyCode) && (isCtrlPressed(e) || isShiftPressed(e))) {
            this._handleSaveClick()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/EditCommentInput.js